import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import { LocalStorageService } from './services/local-storage-service/local-storage.service';

@Injectable()
export class ServerErrorsInterceptor implements HttpInterceptor {
  /** Requests carrying this header handle their own 401/403 and keep the session. */
  static readonly SilentAuthHeader = 'X-Silent-Auth-Failure';

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    if (request.url.endsWith("api/media/GetPreview")) {
      request = request.clone({
        headers: request.headers
          // Remove Cache-Control if previously set
          .delete('Cache-Control')
          .delete('Pragma')
        // Optionally, set Cache-Control to a desired value
        // .set('Cache-Control', 'your-desired-value')
      });
    }


    // A request may opt out of the global "401 means the session is over" rule. A secondary
    // panel asking for something this user is not entitled to must not clear the session and
    // bounce the whole application to the login screen; its own error handler deals with it.
    const silent = request.headers.has(ServerErrorsInterceptor.SilentAuthHeader);
    if (silent) {
      request = request.clone({ headers: request.headers.delete(ServerErrorsInterceptor.SilentAuthHeader) });
    }

    return next.handle(request).pipe(
      tap(event => {
      }),
      catchError((error: HttpErrorResponse) => {

        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }

        if ((error.status == 403 || error.status == 401) && !silent) {
          if (window.location.pathname != "/account/login") {
            this.localStorageService.clear();
            window.location.href = "/account/login";
          }
        }

        if (error.status == 409) {
          return throwError(error);
        }

        // A request that opted out of the global 401 rule handles its own failures, and it can
        // only do that with the response in hand. Everyone else keeps the historic behaviour of
        // receiving a formatted string, which is what the rest of the application expects.
        if (silent) {
          return throwError(error);
        }

        //window.alert(errorMessage);
        return throwError(errorMessage);
      })
    );
  }
}
